import * as d3 from 'd3'

export default {
  methods: {

    draw_schedule(selection, sch_, x_, y_) {

      let val = this.schedule.value

      let schedule = selection
      .append('g')
      .attr('transform', `translate(${x_}, ${y_})`)

      let tY = 5
      // Early Schedule
      schedule
      .append('text')
      .attr('transform', `translate(0, ${tY + (val.tSize - 2)*0.36})`)
      .attr('font-size', val.tSize - 2).attr('fill', '#757575')
      .attr('text-anchor', 'start')
      .text(`Early`)

      tY = tY + val.lineheight
      schedule
      .append('text')
      .attr('transform', `translate(0, ${tY + val.tSize*0.36})`)
      .attr('font-size', val.tSize).attr('fill', val.tColor)
      .attr('text-anchor', 'start')
      .text(this.rawData[`PE_${sch_}`] + '%')

      schedule
      .append('text')
      .attr('id', `EARLY_CUM_${this.localId}`)
      .attr('transform', `translate(65, ${tY + val.tSize*0.36})`)
      .attr('font-size', val.tSize).attr('fill', this.gmx_deltaValue(this.rawData[`DE_${sch_}`]))
      .attr('text-anchor', 'end')
      .text(this.rawData[`DE_${sch_}`] + '%')

      
      schedule // Icon
      .append('path')
      .attr('transform', `translate(${68}, ${tY - 5}) scale(.7)`)
      .attr('d', this.gmx_deltaValue(this.rawData[`DE_${sch_}`], 'icon'))
      .attr('fill', this.gmx_deltaValue(this.rawData[`DE_${sch_}`]))
      .attr('stroke-width', .5)


      tY = tY + val.lineheight
      // Late Schedule
      schedule
      .append('text')
      .attr('transform', `translate(0, ${tY + (val.tSize - 2)*0.36})`)
      .attr('font-size', val.tSize - 2).attr('fill', '#757575')
      .attr('text-anchor', 'start')
      .text(`Late`)

      tY = tY + val.lineheight
      schedule
      .append('text')
      .attr('transform', `translate(0, ${tY + val.tSize*0.36})`)
      .attr('font-size', val.tSize).attr('fill', val.tColor)
      .attr('text-anchor', 'start')
      .text(this.rawData[`PL_${sch_}`]+ '%')

      schedule
      .append('text')
      .attr('id', `LATE_CUM_${this.localId}`)
      .attr('transform', `translate(65, ${tY + val.tSize*0.36})`)
      .attr('font-size', val.tSize).attr('fill', this.gmx_deltaValue(this.rawData[`DL_${sch_}`]))
      .attr('text-anchor', 'end')
      .text(this.rawData[`DL_${sch_}`] + '%')

      
      schedule // Icon
      .append('path')
      .attr('transform', `translate(${68}, ${tY - 5}) scale(.7)`)
      .attr('d', this.gmx_deltaValue(this.rawData[`DL_${sch_}`], 'icon'))
      .attr('fill', this.gmx_deltaValue(this.rawData[`DL_${sch_}`]))
      .attr('stroke-width', .5)
    }




    
  }
}